import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function PrivacyPage() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white font-sans">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-white shadow-sm'}`}>
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center space-x-2 cursor-pointer">
              <div className="text-2xl font-bold text-gray-900">FILLS</div>
              <div className="text-xs text-gray-600">合同会社</div>
            </Link>
            <div className="hidden md:flex items-center space-x-8">
              <Link to="/#home" className="text-sm text-gray-700 hover:opacity-70 transition-colors whitespace-nowrap cursor-pointer">ホーム</Link>
              <Link to="/#about" className="text-sm text-gray-700 hover:opacity-70 transition-colors whitespace-nowrap cursor-pointer">会社概要</Link>
              <Link to="/#business" className="text-sm text-gray-700 hover:opacity-70 transition-colors whitespace-nowrap cursor-pointer">事業内容</Link>
              <Link to="/#services" className="text-sm text-gray-700 hover:opacity-70 transition-colors whitespace-nowrap cursor-pointer">サービス</Link>
              <Link to="/#contact" className="text-sm text-gray-700 hover:opacity-70 transition-colors whitespace-nowrap cursor-pointer">採用・お問い合わせ</Link>
              <Link to="/#access" className="text-sm text-gray-700 hover:opacity-70 transition-colors whitespace-nowrap cursor-pointer">アクセス</Link>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="pt-32 pb-16 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-4xl mx-auto px-6">
          <h1 className="text-5xl font-bold text-gray-900 mb-4">プライバシーポリシー</h1>
          <p className="text-gray-600">最終更新日: 2024年1月15日</p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-6">
          <div className="prose prose-lg max-w-none">
            <div className="mb-12">
              <p className="text-gray-700 leading-relaxed mb-6">
                FILLS合同会社(以下「当社」といいます)は、お客様の個人情報の保護を重要な責務と認識し、以下のプライバシーポリシーに従って適切に取り扱います。
              </p>
            </div>

            <div className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">1. 個人情報の定義</h2>
              <p className="text-gray-700 leading-relaxed">
                個人情報とは、氏名、住所、電話番号、メールアドレスなど、特定の個人を識別できる情報をいいます。
              </p>
            </div>

            <div className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">2. 個人情報の収集</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                当社は、以下の目的で個人情報を収集することがあります:
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                <li>お問い合わせへの対応</li>
                <li>サービスの提供</li>
                <li>採用活動における連絡</li>
                <li>ニュースレターの配信</li>
                <li>マーケティング活動</li>
              </ul>
            </div>

            <div className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">3. 個人情報の利用目的</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                当社は、収集した個人情報を以下の目的で利用します:
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                <li>お客様からのお問い合わせに対する回答</li>
                <li>当社サービスに関する情報提供</li>
                <li>契約の履行</li>
                <li>採用選考の実施</li>
                <li>統計データの作成(個人を特定できない形式)</li>
              </ul>
            </div>

            <div className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">4. 個人情報の第三者提供</h2>
              <p className="text-gray-700 leading-relaxed">
                当社は、法令に基づく場合を除き、お客様の同意なく個人情報を第三者に提供することはありません。
              </p>
            </div>

            <div className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">5. 個人情報の管理</h2>
              <p className="text-gray-700 leading-relaxed">
                当社は、個人情報の漏洩、滅失、毀損を防止するため、適切な安全管理措置を講じます。また、個人情報を取り扱う従業員に対して、適切な監督を行います。
              </p>
            </div>

            <div className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">6. 個人情報の開示・訂正・削除</h2>
              <p className="text-gray-700 leading-relaxed">
                お客様は、当社が保有する自己の個人情報について、開示、訂正、削除を求めることができます。ご希望の場合は、下記のお問い合わせ先までご連絡ください。
              </p>
            </div>

            <div className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Cookie(クッキー)の使用</h2>
              <p className="text-gray-700 leading-relaxed">
                当社のウェブサイトでは、サービスの向上を目的としてCookieを使用する場合があります。Cookieの使用を希望されない場合は、ブラウザの設定で無効にすることができます。
              </p>
            </div>

            <div className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">8. プライバシーポリシーの変更</h2>
              <p className="text-gray-700 leading-relaxed">
                当社は、法令の変更や事業内容の変更に伴い、本プライバシーポリシーを変更することがあります。変更後のプライバシーポリシーは、本ウェブサイトに掲載した時点で効力を生じるものとします。
              </p>
            </div>

            <div className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">9. お問い合わせ窓口</h2>
              <div className="bg-gray-50 p-6 rounded-lg">
                <p className="text-gray-700 leading-relaxed mb-2">
                  <strong className="text-gray-900">FILLS合同会社</strong>
                </p>
                <p className="text-gray-700 leading-relaxed mb-2">
                  〒537-0023<br />
                  大阪府大阪市東成区玉津2丁目11-27-505
                </p>
                <p className="text-gray-700 leading-relaxed">
                  個人情報に関するお問い合わせは、<Link to="/#contact" className="text-teal-600 hover:text-teal-700 underline cursor-pointer">お問い合わせフォーム</Link>よりご連絡ください。
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">ご不明な点がございましたら</h2>
          <p className="text-gray-600 mb-8">お気軽にお問い合わせください</p>
          <Link 
            to="/#contact"
            className="inline-flex items-center gap-3 bg-gray-900 text-white px-8 py-4 rounded-full font-medium hover:bg-gray-800 transition-all whitespace-nowrap cursor-pointer"
          >
            お問い合わせ
            <div className="w-8 h-8 rounded-full bg-white flex items-center justify-center">
              <i className="ri-arrow-right-line text-gray-900 text-sm"></i>
            </div>
          </Link>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#1E3A5F] text-white py-16">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
            <div>
              <div className="text-2xl font-bold mb-4">FILLS</div>
              <div className="space-y-2 text-sm text-gray-300">
                <p>大阪府大阪市東成区玉津</p>
                <p>令和5年設立</p>
                <p>信頼のデジタルパートナー</p>
              </div>
            </div>
            
            <div>
              <h4 className="text-sm font-bold mb-4 uppercase tracking-wider">会社情報</h4>
              <ul className="space-y-2 text-sm text-gray-300">
                <li><Link to="/#about" className="hover:text-white transition-colors cursor-pointer">会社概要</Link></li>
                <li><Link to="/#business" className="hover:text-white transition-colors cursor-pointer">事業内容</Link></li>
                <li><Link to="/privacy" className="hover:text-white transition-colors cursor-pointer">プライバシーポリシー</Link></li>
              </ul>
            </div>
            
            <div>
              <h4 className="text-sm font-bold mb-4 uppercase tracking-wider">サービス</h4>
              <ul className="space-y-2 text-sm text-gray-300">
                <li><Link to="/#services" className="hover:text-white transition-colors cursor-pointer">EC構築</Link></li>
                <li><Link to="/#services" className="hover:text-white transition-colors cursor-pointer">広告運用</Link></li>
                <li><Link to="/#services" className="hover:text-white transition-colors cursor-pointer">情報検索</Link></li>
              </ul>
            </div>
            
            
          </div>
          
          <div className="border-t border-gray-600 pt-8">
            <div className="flex flex-col md:flex-row justify-between items-center gap-4">
              <p className="text-sm text-gray-400">© 2023 FILLS合同会社. All rights reserved.</p>
              
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
